import { useMutation } from '@tanstack/react-query'
import { axiosInstance } from '@/lib/axios'

type AssignDriverCardPayload = {
  driverId: number
  driverCardId: number
  targetDriverId: number
}

export function useMutationAssignDriverCard(companyId: string) {
  return useMutation<unknown, Error, AssignDriverCardPayload>({
    mutationFn: (payload) =>
      axiosInstance.post(`api/${companyId}/driver/assignCard`, payload),
  })
}
